import ApiClient from '../ApiClient';
import EmailService from './EmailService';

const getEmailAuthPayload = () => EmailService.ensureCalendarEmailAuthPayload();

export async function buildAddCalendarEventPayload({
  title,
  startTime,
  durationInMinutes = 30,
  guestEmails = [],
  notes = null,
  isVCEnabled = false,
  meetingProvider = null,
  meetingUrl = null,
  meetingId = null,
}) {
  return {
    title: (title || '').trim(),
    startTime: new Date(startTime).toISOString(),
    durationInMinutes: Number(durationInMinutes) || 30,
    guestEmails,
    notes: notes || null,
    isVCEnabled: Boolean(isVCEnabled),
    meetingProvider: isVCEnabled ? meetingProvider : null,
    meetingUrl: isVCEnabled ? meetingUrl : null,
    externalMeetingId: isVCEnabled ? (meetingId ?? null) : null,
    emailAuth: await getEmailAuthPayload(),
  };
}

export async function buildUpdateCalendarEventPayload({
  id,
  title,
  startTime,
  durationInMinutes = 30,
  guestEmails = [],
  notes = null,
  isVCEnabled = false,
  meetingProvider = null,
  meetingUrl = null,
  meetingId = null,
  sendEmail = false,
}) {
  return {
    id,
    title: (title || '').trim(),
    startTime: new Date(startTime).toISOString(),
    durationInMinutes: Number(durationInMinutes) || 30,
    guestEmails,
    notes: notes || null,
    isVCEnabled: Boolean(isVCEnabled),
    meetingProvider: isVCEnabled ? meetingProvider : null,
    meetingUrl: isVCEnabled ? meetingUrl : null,
    externalMeetingId: isVCEnabled ? (meetingId ?? null) : null,
    sendEmail: Boolean(sendEmail),
    emailAuth: await getEmailAuthPayload(),
  };
}

const CalendarService = {
  async addCalendarEvent(payload) {
    return ApiClient.post('/Calendar/add-calendar-event', payload);
  },

  async updateCalendarEvent(payload) {
    return ApiClient.put('/Calendar/update-calendar-event', payload);
  },

  async getCalendarEvents() {
    return ApiClient.get('/Calendar/calendar-list');
  },

  async deleteCalendarEvent(id) {
    return ApiClient.delete(`/Calendar/delete-calendar-event/${id}`, {
      data: await getEmailAuthPayload(),
    });
  },
};

export default CalendarService;
